module.exports = __webpack_public_path__ + "img/collage_icon_2.35f8a517.svg";